const EditableTable = ({ tableData, setTableData }) => {

    const handleContentChange = (e, index, field) => {
        const updatedTableData = [...tableData];
        updatedTableData[index][field] = e.target.innerText;
        setTableData(updatedTableData);
    };

    const tableContainerStyle = {
        overflowX: 'auto',
    };

    const tableStyle = {
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
    };

    const rowStyle = {
        display: 'table-row',
    };

    const cellStyle = {
        display: 'table-cell',
        border: '1px solid #ddd',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        minWidth: '50px',
    };

    const headerStyle = {
        ...cellStyle,
        backgroundColor: '#f2f2f2',
        fontWeight: 'bold',
    };

    return (
        <div
            id="editable-table-container"
            className="full-w"
            style={tableContainerStyle}
        >
            <div 
                id="editable-table"
                data-testid="editable-table"
                style={tableStyle}
            >
                <div
                    id="editable-table-header-row"
                    style={rowStyle}
                >
                    <div
                        id="editable-table-header-id"
                        className="text-xl py-3 text-center"
                        style={{ ...headerStyle, width: '50px' }}
                    >
                        ID
                    </div>

                    <div
                        id="editable-table-header-source"
                        className="text-xl py-3 text-center"
                        style={{ ...headerStyle, width: '300px' }}
                    >
                        Src Text
                    </div>

                    <div
                        id="editable-table-header-target"
                        className="text-xl py-3 text-center"
                        style={{ ...headerStyle, width: '300px' }}
                    >
                        Tgt Text
                    </div>
                </div>

                {tableData.map((row, index) => (
                    <div
                        key={index}
                        id={`editable-table-row-${index}`}
                        data-testid={`editable-table-row-${index}`}
                        style={rowStyle}
                    >
                        <div
                            id={`editable-table-row-${index}-id`}
                            style={cellStyle}
                            className="text-center"
                        >
                            {index + 1}
                        </div>

                        <div
                            id={`editable-table-row-${index}-source`}
                            name={`editableTable[${index}].srctxt`}
                            data-testid={`editable-table-row-${index}-source`}
                            className="px-3"
                            style={cellStyle}
                            contentEditable
                            suppressContentEditableWarning
                            onBlur={(e) =>
                                handleContentChange(e, index, "srctxt")
                            }
                        >
                            {row.srctxt}
                        </div>

                        <div
                            id={`editable-table-row-${index}-target`}
                            name={`editableTable[${index}].tgttxt`}
                            data-testid={`editable-table-row-${index}-target`}
                            className="px-3"
                            style={cellStyle}
                            contentEditable
                            suppressContentEditableWarning
                            onBlur={(e) =>
                                handleContentChange(e, index, "tgttxt")
                            }
                        >
                            {row.tgttxt}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EditableTable;